import useGetShoppingCartQuery from '../../../../queries/useGetShoppingCartQuery';

interface UseShoppingCartResult {
  shoppingCart: ReturnType<typeof useGetShoppingCartQuery>;
  shoppingCartWithSummary: ReturnType<typeof useGetShoppingCartQuery>;
  /**
   * Refetches shopping cart with summary and updates items in the store
   */
  refetchAndUpdateItems: () => Promise<void>;
}

/**
 * Custom hook for managing shopping cart operations
 * @returns Shopping cart queries and utility functions
 */
export default function useShoppingCart(): UseShoppingCartResult {
  const shoppingCart = useGetShoppingCartQuery();
  const shoppingCartWithSummary = useGetShoppingCartQuery(true);

  /**
   * Refetches shopping cart with summary and updates items in the store
   * @returns The data from the refetch operation
   */
  const refetchAndUpdateItems = async (): Promise<void> => {
    await shoppingCartWithSummary.refetch();
  };

  return {
    shoppingCart,
    shoppingCartWithSummary,
    refetchAndUpdateItems,
  };
}
